webpackJsonp([11],{

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxonomies_vue__ = __webpack_require__(739);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5641446e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxonomies_vue__ = __webpack_require__(857);
function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_taxonomies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5641446e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_taxonomies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_api__ = __webpack_require__(246);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VisibleFor',

  props: __WEBPACK_IMPORTED_MODULE_0_config_api__["a" /* default */].roles,

  data: function data() {
    return {
      visible: false,
      userRol: null
    };
  },

  created: function created() {
    this.userRol = this.$store.getters['api/getUserRol'];
    this.checkUserPrivileges();
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkUserPrivileges: function checkUserPrivileges() {
      this.visible = typeof this.$props[this.userRol] !== 'undefined';
    }
  }
});

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTrue: function isTrue(message) {
        return function (v) {
          return v === true || message || 'Campo requerido';
        };
      },
      isRequired: function isRequired(message) {
        return function (v) {
          if (v && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v).length > 0) {
            return true;
          }
          return !!v && v.length > 0 || message || 'Campo requerido';
        };
      },
      isEmail: function isEmail(v) {
        if (!v.length > 0) return true;
        var regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return regex.test(v) || 'Correo electrónico no válido';
      },
      isComposedBy: function isComposedBy(option, value) {
        var regex = {
          'letters|numbers': /^[A-zÀ-ÖØ-öø-ÿ0-9]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9]*$/,
          'letters|numbers|spaces': /^[A-zÀ-ÖØ-öø-ÿ0-9 ]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9 ]*$/,
          'numbers': /^[0-9]*[0-9][0-9]*$/
        };
        var msg = {
          'letters|numbers': 'Solo números y letras están permitidos',
          'letters|numbers|spaces': 'Solo números, letras y espacios están permitidos',
          'numbers': 'Solo números están permitidos'
        };
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return regex[option].test(v[value]) || msg[option];
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return regex[option].test(value);
            }) || msg[option];
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return regex[option].test(v) || msg[option];
          };
        }
        return true;
      },
      hasLength: function hasLength(chars, value) {
        var msg = 'Debe contener ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length === chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length === chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return !!v && v.length === chars || msg;
          };
        }
        return true;
      },
      hasMaxLength: function hasMaxLength(chars, value) {
        var msg = 'No debe exceder de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length <= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length <= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length <= chars || msg;
          };
        }
        return true;
      },
      hasMinLength: function hasMinLength(chars, value) {
        var msg = 'Debe contener un mínimo de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length >= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length >= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length >= chars || msg;
          };
        }
        return true;
      }
    };
  },


  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setRules: function setRules(rules, value) {
      var items = [];
      for (var rule in rules) {
        rule = rules[rule].split(':');
        switch (rule[0]) {
          case 'required':
            items.push(this.isRequired(rule[1] || null));
            break;
          case 'is_true':
            items.push(this.isTrue(rule[1] || null));
            break;
          case 'has_length':
            items.push(this.hasLength(parseInt(rule[1]), value));
            break;
          case 'has_min_length':
            items.push(this.hasMinLength(parseInt(rule[1]), value));
            break;
          case 'has_max_length':
            items.push(this.hasMaxLength(parseInt(rule[1]), value));
            break;
          case 'is_composed_by':
            items.push(this.isComposedBy(rule[1]));
            break;
          case 'is_email':
            items.push(this.isEmail);
            break;
        }
      }
      return items;
    }
  }
});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(524);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(20);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(525) });


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(526);
var pIE = __webpack_require__(527);
var toObject = __webpack_require__(62);
var IObject = __webpack_require__(245);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(41)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 526:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 527:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(531);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(532), __esModule: true };

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(533);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(20);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_vm._t("content")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyCrudDatatable',

  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },

  props: {
    translations: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: null,
      required: true
    },
    pluralName: {
      type: String,
      default: null,
      required: true
    },
    rowsPerPageItems: {
      type: Array,
      default: null
    },
    headers: {
      type: Array,
      default: null,
      required: true
    },
    rows: {
      type: Array,
      default: null,
      required: true
    },
    itemKey: {
      type: String,
      default: 'id'
    },
    checkboxColor: {
      type: String,
      default: 'primary'
    },
    primaryColor: {
      type: String,
      default: 'primary'
    },
    primaryButtonColor: {
      type: String,
      default: 'primary'
    },
    secundaryButtonColor: {
      type: String,
      default: 'secundary'
    },
    selectedColumns: {
      type: Array,
      default: null
    },
    business: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    companies: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    commerces: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    installers: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: false
    },
    pagination: {
      type: Object,
      default: null
    },
    defaultColumns: {
      type: Object,
      default: null,
      required: true
    },
    addDialog: {
      type: Boolean,
      default: true,
      required: false
    },
    editDialog: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    cloneButton: {
      type: Boolean,
      default: false,
      required: false
    },
    displayFilters: {
      type: Boolean,
      default: false,
      required: false
    },
    markButton: {
      type: Boolean,
      default: false,
      required: false
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    /**
     * Translations for button texts.
     * @default null
     * @type {Object}
     */
    translatiosns: {
      type: Object,
      default: null
    }
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },

  data: function data() {
    return {
      dateOptions: [{
        text: 'Inicio instalación',
        value: 'booking_installation_start_date'
      }, {
        text: 'Fin instalación',
        value: 'booking_installation_end_date'
      }, {
        text: 'Fecha de venta',
        value: 'sale_sold_date'
      }],
      statuses: [{
        text: 'Pendiente',
        value: 6
      }, {
        text: 'Cita programada',
        value: 13
      }, {
        text: 'En transcurso',
        value: 7
      }, {
        text: 'Anulada',
        value: 8
      }, {
        text: 'Aplazada',
        value: 9
      }, {
        text: 'No instalada por iBEC',
        value: 14
      }, {
        text: 'Terminada sin incidencias',
        value: 10
      }, {
        text: 'Terminada con incidencias',
        value: 11
      }, {
        text: 'Pendiente',
        value: 6
      }],
      dateFromMenu: null,
      dateToMenu: null,
      dateFrom: null,
      dateTo: null,
      filterBy: null,
      status: null,
      customColumns: null,
      b: null,
      sheet: false,
      arrayMove: __webpack_require__(614),
      isDraggable: false,
      isLoaded: false,
      theHeaders: [],
      isDragging: false,
      delayedDragging: false,
      items: [],
      availableColumns: [],
      editedItemIndex: -1,
      editedHeaderIndex: -1,
      editedItem: [],
      selectedBusiness: null,
      selectedCompany: null,
      selectedCommerce: null,
      selectedInstaller: null,
      defaultItem: [],
      search: '',
      actions: false,
      checkbox: false,
      selected: [],
      dialog: false,
      dialogConfirm: false,
      text: {
        'new': 'New',
        'edit': 'Edit',
        'cancel': 'Cancel',
        'save': 'Save',
        'delete': 'Delete',
        'columns': 'Colums',
        'columns_info': 'To change the order of the columns, simply drag them from one place to another',
        'columns_warning': 'WARNING: This will remove your custom selection and reset the columns to the default selection',
        'restart_columns': 'Reset columns',
        'reset': 'Reset',
        'delete_selecteds': 'Deleted selected',
        'clone_selecteds': 'Clone selected',
        'mark_selecteds': 'Mark selected',
        'delete_element': 'Delete item',
        'delete_element_message': 'You\'re about to delete an ',
        'search': 'Search',
        'rows_per_page_items': 'Rows per page',
        'no_results_text': 'No data available',
        'no_data_text': 'No matches found',
        'from': 'From',
        'to': 'to',
        'no_results_found_for': 'No results found for'
      },
      rowsPerPage: [5, 10, 25, { 'text': 'All', 'value': -1 }],
      customPagination: {
        'sortBy': 'id',
        'ascending': true,
        'rowsPerPage': -1
      }
    };
  },

  computed: {
    formTitle: function formTitle() {
      return this.editedItemIndex === -1 ? this.text['new'] + ' ' + this.name : this.text['edit'] + ' ' + this.name;
    },
    dateToo: function dateToo() {
      return this.dateTo ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateTo).format('DD-MM-YYYY') : null;
    },
    dateFromm: function dateFromm() {
      return this.dateFrom ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.dateFrom).format('DD-MM-YYYY') : null;
    }
  },

  watch: {
    filterBy: function filterBy(val) {
      this.onChangeFilters();
    },
    status: function status(val) {
      this.onChangeFilters();
    },
    dateFrom: function dateFrom(val) {
      this.onChangeFilters();
    },
    dateTo: function dateTo(val) {
      this.onChangeFilters();
    },
    selectedBusiness: function selectedBusiness(val) {
      this.onChangeFilters();
    },
    selectedCompany: function selectedCompany(val) {
      this.onChangeFilters();
    },
    selectedCommerce: function selectedCommerce(val) {
      this.onChangeFilters();
    },
    selectedInstaller: function selectedInstaller(val) {
      this.onChangeFilters();
    },
    dialog: function dialog(val) {
      val || this.close();
    },
    dialogConfirm: function dialogConfirm(val) {
      val || this.close();
    },
    headers: function headers() {
      this.normalizeColumns();
    },
    rows: function rows() {
      this.items = this.rows;
      this.initialize();
    },
    selectedColumns: function selectedColumns() {
      this.customColumns = this.selectedColumns;
      this.normalizeColumns();
    },
    customColumns: function customColumns() {
      this.$emit('on-change-columns', this.customColumns);
    },
    isDragging: function isDragging(newValue) {
      var _this = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this.delayedDragging = false;
      });
    }
  },

  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeColumns: function normalizeColumns() {
      var _this2 = this;

      this.theHeaders = [];
      this.theHeaders.push({
        text: 'checkbox',
        value: 'checkbox',
        type: 'checkbox',
        fixed: true
      });
      this.setAvailableColumns();
      var selectedColumns = this.selectedColumns && this.selectedColumns.length ? this.selectedColumns : this.availableColumns;
      selectedColumns.forEach(function (value) {
        var index = _this2.headers.findIndex(function (item) {
          return item.value === value;
        });
        if (index !== -1) {
          _this2.theHeaders.push(_this2.headers[index]);
        }
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    calculateIndex: function calculateIndex(value) {
      var index = this.availableColumns.indexOf(value);
      var iterator = index - 1;
      while (iterator > -1) {
        var _value = this.availableColumns[iterator];
        var i = this.customColumns.indexOf(_value);
        if (i > -1) {
          return i + 1;
        }
        iterator--;
      }
      iterator = index + 1;
      while (iterator < this.availableColumns.length) {
        var _value2 = this.availableColumns[iterator];
        var _i = this.customColumns.indexOf(_value2);
        if (_i > -1) {
          return _i - 1;
        }
        iterator++;
      }
      return -1;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setColumnsVisibility: function setColumnsVisibility(value) {
      var index = this.headers.findIndex(function (item) {
        return item.value === value;
      });
      var customColumnIndex = this.customColumns.indexOf(value);
      if (customColumnIndex > -1) {
        this.customColumns.splice(customColumnIndex, 1);
        var newIndex = this.calculateIndex(value);
        this.customColumns.splice(newIndex, 0, value);
        return this.theHeaders.splice(newIndex, 0, this.headers[index]);
      }
      index = this.theHeaders.findIndex(function (item) {
        return item.value === value;
      });
      // console.log(index)
      this.theHeaders.splice(index, 1);
    },
    saveDate: function saveDate(type) {
      if (type === 'start') {
        this.$refs.dateFromMenu.save(this.dateFrom);
        this.dateFromMenu = false;
      } else {
        this.$refs.dateToMenu.save(this.dateTo);
        this.dateToMenu = false;
      }
    },
    setFilters: function setFilters(filters) {
      this.filterBy = filters.filterBy || null;
      this.status = filters.status || null;
      this.dateFrom = filters.dateFrom || null;
      this.dateTo = filters.dateTo || null;
      this.selectedBusiness = filters.business || null;
      this.selectedCompany = filters.company || null;
      this.selectedCommerce = filters.commerce || null;
      this.selectedInstaller = filters.installer || null;
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      this.isDraggable = (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
      return this.isDraggable;
    },
    onChangeFilters: function onChangeFilters() {
      this.$emit('on-change-filters', {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        filterBy: this.filterBy,
        status: this.status,
        business: this.selectedBusiness,
        company: this.selectedCompany,
        commerce: this.selectedCommerce,
        installer: this.selectedInstaller
      });
    },
    onStart: function onStart(event) {
      this.isDragging = true;
      return false;
    },
    onEnd: function onEnd(event) {
      this.isDragging = false;
      this.theHeaders = this.arrayMove(this.theHeaders, event.oldIndex, event.newIndex);
      this.initialize();
    },
    setCustomColumns: function setCustomColumns() {
      var _this3 = this;

      this.customColumns = [];
      this.theHeaders.forEach(function (obj, index) {
        _this3.customColumns.push(obj.value);
      });
    },
    setAvailableColumns: function setAvailableColumns() {
      var _this4 = this;

      this.availableColumns = [];
      this.availableColumns.push('checkbox');
      this.headers.forEach(function (obj, index) {
        _this4.availableColumns.push(obj.value);
      });
    },
    getOptions: function getOptions() {
      return {
        sort: true,
        animation: 500,
        group: {
          name: 'tags',
          pull: true,
          put: true
        },
        disabled: false,
        ghostClass: 'ghost'
      };
    },
    resetFilters: function resetFilters() {
      this.setFilters({
        dateFrom: null,
        dateTo: null,
        filterBy: null,
        status: null,
        business: null,
        company: null,
        commerce: null,
        installer: null
      });
    },
    resetColumns: function resetColumns() {
      var _this5 = this;

      this.customColumns = this.availableColumns;
      this.theHeaders = [];
      this.theHeaders.push({
        text: 'checkbox',
        value: 'checkbox',
        type: 'checkbox',
        fixed: true
      });
      this.headers.forEach(function (obj, index) {
        _this5.theHeaders.push(obj);
      });
    },
    changeSort: function changeSort(column) {
      if (this.customPagination.sortBy === column) {
        this.customPagination.descending = !this.customPagination.descending;
      } else {
        this.customPagination.sortBy = column;
        this.customPagination.descending = false;
      }
    },
    initialize: function initialize() {
      var _this6 = this;

      this.setCustomColumns();
      this.text = this.translations || this.text;
      this.items = this.rows || this.items;

      this.customPagination = this.pagination || this.customPagination;
      var defaultColumns = {};
      for (var key in this.defaultColumns) {
        defaultColumns[key] = this.defaultColumns[key];
      }

      var editedItem = {};
      for (key in this.defaultColumns) {
        editedItem[key] = this.defaultColumns[key];
      }

      this.defaultItem = defaultColumns;
      this.editedItem = editedItem;

      this.actions = this.theHeaders.findIndex(function (item) {
        return item.type === 'actions';
      }) > -1;

      this.checkbox = typeof defaultColumns.value !== 'undefined' ? this.checkboxColor : false;

      setTimeout(function () {
        _this6.isLoaded = true;
      }, 1000);
    },
    sortColumns: function sortColumns(elements) {
      // console.log('++++', elements)
      var items = {};
      this.theHeaders.forEach(function (item, index) {
        if (item.value !== 'checkbox') {
          items[item.value] = elements[item.value];
        }
      });
      // console.log('++++', items)
      elements = items;
      return elements;
    },
    getIndexByValue: function getIndexByValue(value) {
      return this.theHeaders.findIndex(function (item) {
        return item.value === value;
      });
    },
    getIndexByItemKey: function getIndexByItemKey(itemKey) {
      var _this7 = this;

      return this.items.findIndex(function (item) {
        return item[_this7.itemKey] === itemKey;
      });
    },
    getItemLabelByValue: function getItemLabelByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].text;
      }
      return '';
    },
    getItemOptionsByValue: function getItemOptionsByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].options;
      }
      return '';
    },
    getItemPropTextByValue: function getItemPropTextByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].property_text;
      }
      return '';
    },
    getItemPropValueByValue: function getItemPropValueByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].property_value;
      }
      return '';
    },
    getItemTypeByValue: function getItemTypeByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].type;
      }
      return '';
    },
    getItemRulesByValue: function getItemRulesByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].rules;
      }
      return '';
    },
    getItemCounterByValue: function getItemCounterByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].counter;
      }
      return '';
    },
    getMainItemByIndex: function getMainItemByIndex(index) {
      return this.theHeaders.findIndex(function (item) {
        return typeof item.main !== 'undefined';
      });
    },
    getItemVisibilityByValue: function getItemVisibilityByValue(value) {
      var index = this.getIndexByValue(value);
      if (index !== false && this.theHeaders[index]) {
        return this.theHeaders[index].editable || false;
      }
      return false;
    },
    getConfirmationMessage: function getConfirmationMessage() {
      var index = this.editedHeaderIndex;
      var headerText = this.theHeaders[index] ? this.theHeaders[index].text.toLowerCase() : '';
      var headerValue = this.theHeaders[index] ? this.theHeaders[index].value : '';

      return this.text['delete_element_message'] + ' ' + headerText + ' ' + this.editedItem[headerValue] + '.';
    },
    editItem: function editItem(index, value) {
      if (this.editDialog) {
        this.editedItemIndex = index;
        this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.items[index]);
        this.dialog = true;
      }
      this.$emit('on-click-edit-button', index, value);
    },
    editInputText: function editInputText(index) {
      this.$emit('on-edit', index);
    },
    confirmDeletion: function confirmDeletion(index) {
      this.editedHeaderIndex = this.getMainItemByIndex(index);
      this.editedItemIndex = index;
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.items[index]);
      this.dialogConfirm = true;
    },
    markItem: function markItem(item) {
      this.$emit('on-mark', item);
    },
    cloneItem: function cloneItem(index) {
      this.$emit('on-clone', index);
    },
    deleteItem: function deleteItem(index) {
      this.$emit('on-delete', index);
      this.items.splice(index, 1);
      this.close();
    },
    close: function close() {
      var _this8 = this;

      this.dialog = false;
      this.dialogConfirm = false;
      setTimeout(function () {
        _this8.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this8.defaultItem);
        _this8.editedItemIndex = -1;
        _this8.editedHeaderIndex = -1;
      }, 500);
    },
    onClickAddButton: function onClickAddButton() {
      if (this.addDialog) {
        this.dialog = true;
      }
      this.$emit('on-click-add-button');
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
    },
    selectAll: function selectAll() {
      this.selected = this.items.slice();
    },
    save: function save() {
      if (this.editedItemIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.items[this.editedItemIndex], this.editedItem);
        this.$emit('on-edit', this.editedItemIndex);
      } else {
        var index = 0;
        if (this.items.length > 0) {
          index = this.items[this.items.length - 1][this.itemKey];
        }
        this.editedItem[this.itemKey] = index + 1;
        var item = {};
        for (var i in this.editedItem) {
          if (this.editedItem[i] !== false) {
            item[i] = {};
            item[i] = this.editedItem[i];
          }
        }
        this.items.push(item);
        this.$emit('on-add', this.items.length - 1);
      }
      this.close();
    },
    markSelected: function markSelected() {
      for (var i in this.selected) {
        this.markItem(this.selected[i]);
      }
      this.selected = [];
    },
    cloneSelected: function cloneSelected() {
      for (var i in this.selected) {
        var index = this.items.indexOf(this.selected[i]);
        this.cloneItem(index);
      }
      this.selected = [];
    },
    deleteSelected: function deleteSelected() {
      for (var i in this.selected) {
        var index = this.items.indexOf(this.selected[i]);
        this.deleteItem(index);
      }
      this.selected = [];
    }
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(556), __esModule: true };

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_crud_datatable_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5761a17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_crud_datatable_vue__ = __webpack_require__(615);
function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_crud_datatable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5761a17a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_crud_datatable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(611);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("2be0f5f2", content, true, {});

/***/ }),

/***/ 611:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".card{background-color:#fff!important;border-color:#fff!important}.ghost{opacity:.4;border:1px dotted #e0e0e0}.opacity-all{opacity:0;pointer-events:none;cursor:default;text-decoration:none;-webkit-transition:opacity .4s ease-out;transition:opacity .4s ease-out}.opacity-off{opacity:1;-webkit-transition:opacity .4s ease-in;transition:opacity .4s ease-in}.settings-btn{margin-bottom:48px}.checkbox-column{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 1 auto;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:180px}.flip-list-move{-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.flip-list-item{display:inline-block;margin-right:10px}.flip-list-enter-active,.flip-list-leave-active{-webkit-transition:all .3s;transition:all .3s}.flip-list-enter,.flip-list-leave-to{opacity:0;-webkit-transform:translateY(-50px);transform:translateY(-50px)}.no-drag{-webkit-user-drag:none;-webkit-user-drag--khtml-user-drag:none;-webkit-user-drag--moz-user-drag:none;-webkit-user-drag--o-user-drag:none;-webkit-user-drag-user-drag:none}.no-move{-webkit-transition:-webkit-transform 0s;transition:-webkit-transform 0s;transition:transform 0s;transition:transform 0s,-webkit-transform 0s}.checkbox-column>div>label{font-size:12px}.info-icon{cursor:pointer;margin-left:3px}.options-card{padding:30px 0 30px 40px}.checkboxes{margin-left:5px}.reset-btn{margin-left:19px}.close{z-index:9999999999!important;top:0;margin:22px 7px 0 0}.close-icon{font-size:35px;color:#757575!important}#vuetify-crud-datatable{margin-bottom:50px}.item-row{cursor:pointer}.item-row:hover{background:rgba(0,0,0,.1)!important}.filter-select>div{max-height:30px!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-crud-datatable.vue"],"names":[],"mappings":"AACA,MACE,gCAAqC,AACrC,2BAAiC,CAClC,AACD,OACE,WAAa,AACb,yBAA2B,CAC5B,AACD,aACE,UAAW,AACX,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,wCAA0C,AAC1C,+BAAkC,CACnC,AACD,aACE,UAAW,AACX,uCAAyC,AACzC,8BAAiC,CAClC,AACD,cACE,kBAAoB,CACrB,AACD,iBACE,yBAA0B,AAC1B,sBAAuB,AACvB,mBAAoB,AACpB,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,mBAAoB,AACpB,kBAAmB,AACnB,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,eAAiB,CAClB,AACD,gBACE,yCAA2C,AAC3C,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,gBACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,gDACE,2BAA6B,AAC7B,kBAAqB,CACtB,AACD,qCACE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,SACE,uBAAwB,AACtB,wCAAyC,AACzC,sCAAuC,AACvC,oCAAqC,AACrC,gCAAkC,CACrC,AACD,SACE,wCAAyC,AACzC,gCAAiC,AACjC,wBAAyB,AACzB,4CAA+C,CAChD,AACD,2BACE,cAAgB,CACjB,AACD,WACE,eAAgB,AAChB,eAAiB,CAClB,AACD,cACE,wBAA4B,CAC7B,AACD,YACE,eAAiB,CAClB,AACD,WACE,gBAAkB,CACnB,AACD,OACE,6BAA+B,AAC/B,MAAO,AACP,mBAAqB,CACtB,AACD,YACE,eAAgB,AAChB,uBAA0B,CAC3B,AACD,wBACE,kBAAoB,CACrB,AACD,UACE,cAAgB,CACjB,AACD,gBACE,mCAA0C,CAC3C,AACD,mBACE,yBAA4B,CAC7B","file":"vuetify-crud-datatable.vue","sourcesContent":["\n.card {\n  background-color: #ffffff !important;\n  border-color: #ffffff !important;\n}\n.ghost {\n  opacity: 0.4;\n  border: 1px dotted #e0e0e0;\n}\n.opacity-all {\n  opacity: 0;\n  pointer-events: none;\n  cursor: default;\n  text-decoration: none;\n  -webkit-transition: opacity 0.4s ease-out;\n  transition: opacity 0.4s ease-out;\n}\n.opacity-off {\n  opacity: 1;\n  -webkit-transition: opacity 0.4s ease-in;\n  transition: opacity 0.4s ease-in;\n}\n.settings-btn {\n  margin-bottom: 48px;\n}\n.checkbox-column {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 1 auto;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-width: 180px;\n}\n.flip-list-move {\n  -webkit-transition: -webkit-transform 0.3s;\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n}\n.flip-list-item {\n  display: inline-block;\n  margin-right: 10px;\n}\n.flip-list-enter-active, .flip-list-leave-active {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.flip-list-enter, .flip-list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(-50px);\n          transform: translateY(-50px);\n}\n.no-drag {\n  -webkit-user-drag: none;\n    -webkit-user-drag--khtml-user-drag: none;\n    -webkit-user-drag--moz-user-drag: none;\n    -webkit-user-drag--o-user-drag: none;\n    -webkit-user-drag-user-drag: none;\n}\n.no-move {\n  -webkit-transition: -webkit-transform 0s;\n  transition: -webkit-transform 0s;\n  transition: transform 0s;\n  transition: transform 0s, -webkit-transform 0s;\n}\n.checkbox-column > div > label {\n  font-size: 12px;\n}\n.info-icon {\n  cursor: pointer;\n  margin-left: 3px;\n}\n.options-card {\n  padding: 30px 0px 30px 40px;\n}\n.checkboxes {\n  margin-left: 5px;\n}\n.reset-btn {\n  margin-left: 19px;\n}\n.close {\n  z-index: 9999999999 !important;\n  top: 0;\n  margin: 22px 7px 0 0;\n}\n.close-icon {\n  font-size: 35px;\n  color: #757575 !important;\n}\n#vuetify-crud-datatable {\n  margin-bottom: 50px;\n}\n.item-row {\n  cursor: pointer;\n}\n.item-row:hover {\n  background: rgba(0, 0, 0, 0.1) !important;\n}\n.filter-select > div {\n  max-height: 30px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
  "use strict";

  if (!Array.from) {
    Array.from = function (object) {
      return [].slice.call(object);
    };
  }

  function buildAttribute(object, propName, value) {
    if (value == undefined) {
      return object;
    }
    object = object == null ? {} : object;
    object[propName] = value;
    return object;
  }

  function buildDraggable(Sortable) {
    function removeNode(node) {
      node.parentElement.removeChild(node);
    }

    function insertNodeAt(fatherNode, node, position) {
      var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
      fatherNode.insertBefore(node, refNode);
    }

    function computeVmIndex(vnodes, element) {
      return vnodes.map(function (elt) {
        return elt.elm;
      }).indexOf(element);
    }

    function _computeIndexes(slots, children, isTransition) {
      if (!slots) {
        return [];
      }

      var elmFromNodes = slots.map(function (elt) {
        return elt.elm;
      });
      var rawIndexes = [].concat(_toConsumableArray(children)).map(function (elt) {
        return elmFromNodes.indexOf(elt);
      });
      return isTransition ? rawIndexes.filter(function (ind) {
        return ind !== -1;
      }) : rawIndexes;
    }

    function emit(evtName, evtData) {
      var _this = this;

      this.$nextTick(function () {
        return _this.$emit(evtName.toLowerCase(), evtData);
      });
    }

    function delegateAndEmit(evtName) {
      var _this2 = this;

      return function (evtData) {
        if (_this2.realList !== null) {
          _this2['onDrag' + evtName](evtData);
        }
        emit.call(_this2, evtName, evtData);
      };
    }

    var eventsListened = ['Start', 'Add', 'Remove', 'Update', 'End'];
    var eventsToEmit = ['Choose', 'Sort', 'Filter', 'Clone'];
    var readonlyProperties = ['Move'].concat(eventsListened, eventsToEmit).map(function (evt) {
      return 'on' + evt;
    });
    var draggingElement = null;

    var props = {
      options: Object,
      list: {
        type: Array,
        required: false,
        default: null
      },
      value: {
        type: Array,
        required: false,
        default: null
      },
      noTransitionOnDrag: {
        type: Boolean,
        default: false
      },
      clone: {
        type: Function,
        default: function _default(original) {
          return original;
        }
      },
      element: {
        type: String,
        default: 'div'
      },
      move: {
        type: Function,
        default: null
      },
      componentData: {
        type: Object,
        required: false,
        default: null
      }
    };

    var draggableComponent = {
      name: 'draggable',

      props: props,

      data: function data() {
        return {
          transitionMode: false,
          noneFunctionalComponentMode: false,
          init: false
        };
      },
      render: function render(h) {
        var slots = this.$slots.default;
        if (slots && slots.length === 1) {
          var child = slots[0];
          if (child.componentOptions && child.componentOptions.tag === "transition-group") {
            this.transitionMode = true;
          }
        }
        var children = slots;
        var footer = this.$slots.footer;

        if (footer) {
          children = slots ? [].concat(_toConsumableArray(slots), _toConsumableArray(footer)) : [].concat(_toConsumableArray(footer));
        }
        var attributes = null;
        var update = function update(name, value) {
          attributes = buildAttribute(attributes, name, value);
        };
        update('attrs', this.$attrs);
        if (this.componentData) {
          var _componentData = this.componentData,
              on = _componentData.on,
              _props = _componentData.props;

          update('on', on);
          update('props', _props);
        }
        return h(this.element, attributes, children);
      },
      mounted: function mounted() {
        var _this3 = this;

        this.noneFunctionalComponentMode = this.element.toLowerCase() !== this.$el.nodeName.toLowerCase();
        if (this.noneFunctionalComponentMode && this.transitionMode) {
          throw new Error('Transition-group inside component is not supported. Please alter element value or remove transition-group. Current element value: ' + this.element);
        }
        var optionsAdded = {};
        eventsListened.forEach(function (elt) {
          optionsAdded['on' + elt] = delegateAndEmit.call(_this3, elt);
        });

        eventsToEmit.forEach(function (elt) {
          optionsAdded['on' + elt] = emit.bind(_this3, elt);
        });

        var options = _extends({}, this.options, optionsAdded, { onMove: function onMove(evt, originalEvent) {
            return _this3.onDragMove(evt, originalEvent);
          } });
        !('draggable' in options) && (options.draggable = '>*');
        this._sortable = new Sortable(this.rootContainer, options);
        this.computeIndexes();
      },
      beforeDestroy: function beforeDestroy() {
        this._sortable.destroy();
      },


      computed: {
        rootContainer: function rootContainer() {
          return this.transitionMode ? this.$el.children[0] : this.$el;
        },
        isCloning: function isCloning() {
          return !!this.options && !!this.options.group && this.options.group.pull === 'clone';
        },
        realList: function realList() {
          return !!this.list ? this.list : this.value;
        }
      },

      watch: {
        options: {
          handler: function handler(newOptionValue) {
            for (var property in newOptionValue) {
              if (readonlyProperties.indexOf(property) == -1) {
                this._sortable.option(property, newOptionValue[property]);
              }
            }
          },

          deep: true
        },

        realList: function realList() {
          this.computeIndexes();
        }
      },

      methods: {
        getChildrenNodes: function getChildrenNodes() {
          if (!this.init) {
            this.noneFunctionalComponentMode = this.noneFunctionalComponentMode && this.$children.length == 1;
            this.init = true;
          }

          if (this.noneFunctionalComponentMode) {
            return this.$children[0].$slots.default;
          }
          var rawNodes = this.$slots.default;
          return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
        },
        computeIndexes: function computeIndexes() {
          var _this4 = this;

          this.$nextTick(function () {
            _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode);
          });
        },
        getUnderlyingVm: function getUnderlyingVm(htmlElt) {
          var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
          if (index === -1) {
            //Edge case during move callback: related element might be
            //an element different from collection
            return null;
          }
          var element = this.realList[index];
          return { index: index, element: element };
        },
        getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
          var __vue__ = _ref.__vue__;

          if (!__vue__ || !__vue__.$options || __vue__.$options._componentTag !== "transition-group") {
            return __vue__;
          }
          return __vue__.$parent;
        },
        emitChanges: function emitChanges(evt) {
          var _this5 = this;

          this.$nextTick(function () {
            _this5.$emit('change', evt);
          });
        },
        alterList: function alterList(onList) {
          if (!!this.list) {
            onList(this.list);
          } else {
            var newList = [].concat(_toConsumableArray(this.value));
            onList(newList);
            this.$emit('input', newList);
          }
        },
        spliceList: function spliceList() {
          var _arguments = arguments;

          var spliceList = function spliceList(list) {
            return list.splice.apply(list, _arguments);
          };
          this.alterList(spliceList);
        },
        updatePosition: function updatePosition(oldIndex, newIndex) {
          var updatePosition = function updatePosition(list) {
            return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
          };
          this.alterList(updatePosition);
        },
        getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
          var to = _ref2.to,
              related = _ref2.related;

          var component = this.getUnderlyingPotencialDraggableComponent(to);
          if (!component) {
            return { component: component };
          }
          var list = component.realList;
          var context = { list: list, component: component };
          if (to !== related && list && component.getUnderlyingVm) {
            var destination = component.getUnderlyingVm(related);
            if (destination) {
              return _extends(destination, context);
            }
          }

          return context;
        },
        getVmIndex: function getVmIndex(domIndex) {
          var indexes = this.visibleIndexes;
          var numberIndexes = indexes.length;
          return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
        },
        getComponent: function getComponent() {
          return this.$slots.default[0].componentInstance;
        },
        resetTransitionData: function resetTransitionData(index) {
          if (!this.noTransitionOnDrag || !this.transitionMode) {
            return;
          }
          var nodes = this.getChildrenNodes();
          nodes[index].data = null;
          var transitionContainer = this.getComponent();
          transitionContainer.children = [];
          transitionContainer.kept = undefined;
        },
        onDragStart: function onDragStart(evt) {
          this.context = this.getUnderlyingVm(evt.item);
          evt.item._underlying_vm_ = this.clone(this.context.element);
          draggingElement = evt.item;
        },
        onDragAdd: function onDragAdd(evt) {
          var element = evt.item._underlying_vm_;
          if (element === undefined) {
            return;
          }
          removeNode(evt.item);
          var newIndex = this.getVmIndex(evt.newIndex);
          this.spliceList(newIndex, 0, element);
          this.computeIndexes();
          var added = { element: element, newIndex: newIndex };
          this.emitChanges({ added: added });
        },
        onDragRemove: function onDragRemove(evt) {
          insertNodeAt(this.rootContainer, evt.item, evt.oldIndex);
          if (this.isCloning) {
            removeNode(evt.clone);
            return;
          }
          var oldIndex = this.context.index;
          this.spliceList(oldIndex, 1);
          var removed = { element: this.context.element, oldIndex: oldIndex };
          this.resetTransitionData(oldIndex);
          this.emitChanges({ removed: removed });
        },
        onDragUpdate: function onDragUpdate(evt) {
          removeNode(evt.item);
          insertNodeAt(evt.from, evt.item, evt.oldIndex);
          var oldIndex = this.context.index;
          var newIndex = this.getVmIndex(evt.newIndex);
          this.updatePosition(oldIndex, newIndex);
          var moved = { element: this.context.element, oldIndex: oldIndex, newIndex: newIndex };
          this.emitChanges({ moved: moved });
        },
        computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
          if (!relatedContext.element) {
            return 0;
          }
          var domChildren = [].concat(_toConsumableArray(evt.to.children)).filter(function (el) {
            return el.style['display'] !== 'none';
          });
          var currentDOMIndex = domChildren.indexOf(evt.related);
          var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
          var draggedInList = domChildren.indexOf(draggingElement) != -1;
          return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
        },
        onDragMove: function onDragMove(evt, originalEvent) {
          var onMove = this.move;
          if (!onMove || !this.realList) {
            return true;
          }

          var relatedContext = this.getRelatedContextFromMoveEvent(evt);
          var draggedContext = this.context;
          var futureIndex = this.computeFutureIndex(relatedContext, evt);
          _extends(draggedContext, { futureIndex: futureIndex });
          _extends(evt, { relatedContext: relatedContext, draggedContext: draggedContext });
          return onMove(evt, originalEvent);
        },
        onDragEnd: function onDragEnd(evt) {
          this.computeIndexes();
          draggingElement = null;
        }
      }
    };
    return draggableComponent;
  }

  if (true) {
    var Sortable = __webpack_require__(613);
    module.exports = buildDraggable(Sortable);
  } else if (typeof define == "function" && define.amd) {
    define(['sortablejs'], function (Sortable) {
      return buildDraggable(Sortable);
    });
  } else if (window && window.Vue && window.Sortable) {
    var draggable = buildDraggable(window.Sortable);
    Vue.component('draggable', draggable);
  }
})();

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window === "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,
		lastDownEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		R_SPACE = /\s+/g,
		R_FLOAT = /left|right|inline/,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,
		setTimeout = win.setTimeout,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		captureMode = false,
		passiveMode = false,

		supportDraggable = ('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/(?:Trident.*rv[ :]?11\.|msie)/i)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,

		savedInputChecked = [],
		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var _this = rootEl[expando],
					el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);
			group.revertClone = originalGroup.revertClone;

			options.group = group;
		}
	;

	// Detect support a passive mode
	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function () {
				// `false`, because everything starts to work incorrectly and instead of d'n'd,
				// begins the page has scrolled.
				passiveMode = false;
				captureMode = {
					capture: false,
					passive: passiveMode
				};
			}
		}));
	} catch (err) {}

	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0},
			supportPointer: Sortable.supportPointer !== false
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		options.supportPointer && _on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				preventOnFilter = options.preventOnFilter,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0]) || target,
				filter = options.filter,
				startIndex;

			_saveInputCheckedState(el);


			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			// cancel dnd if original target is content editable
			if (originalTarget.isContentEditable) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'all';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);
				options.supportPointer && _on(ownerDocument, 'pointercancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					options.supportPointer && _on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}


			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					_nextTick(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
				var parent = target;
				var i = touchDragOverListeners.length;

				if (target && target.shadowRoot) {
					target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
					parent = target;
				}

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var _this = this;
			var dataTransfer = evt.dataTransfer;
			var options = _this.options;

			_this._offUpEvents();

			if (activeGroup.checkPull(_this, _this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, _this.options.chosenClass, false);

				// #1143: IFrame support workaround
				_this._cloneId = _nextTick(function () {
					rootEl.insertBefore(cloneEl, dragEl);
					_dispatchEvent(_this, rootEl, 'clone', dragEl);
				});
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', _this._onTouchMove);
					_on(document, 'touchend', _this._onDrop);
					_on(document, 'touchcancel', _this._onDrop);

					if (options.supportPointer) {
						_on(document, 'pointermove', _this._onTouchMove);
						_on(document, 'pointerup', _this._onDrop);
					}
				} else {
					// Old brwoser
					_on(document, 'mousemove', _this._onTouchMove);
					_on(document, 'mouseup', _this._onDrop);
				}

				_this._loopId = setInterval(_this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(_this, dataTransfer, dragEl);
				}

				_on(document, 'drop', _this);

				// #1143: Бывает элемент с IFrame внутри блокирует `drop`,
				// поэтому если вызвался `mouseover`, значит надо отменять весь d'n'd.
				// Breaking Chrome 62+
				// _on(document, 'mouseover', _this);

				_this._dragStartId = _nextTick(_this._dragStarted);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				isMovingBetweenSortable = false,
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						(
							(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
							group.checkPut(this, activeSortable, dragEl, evt)
						)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();

				if (putSortable !== this) {
					putSortable = this;
					isMovingBetweenSortable = true;
				}

				if (revert) {
					_cloneHide(activeSortable, true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (_ghostIsLast(el, evt))
				) {
					//assign target only if condition is true
					if (el.children.length !== 0 && el.children[0] !== ghostEl && el === evt.target) {
						target = el.lastElementChild;
					}

					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(activeSortable, isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						after = false
					;

					if (floating) {
						var elTop = dragEl.offsetTop,
							tgTop = target.offsetTop;

						if (elTop === tgTop) {
							after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
						}
						else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
							after = (evt.clientY - targetRect.top) / height > 0.5;
						} else {
							after = tgTop > elTop;
						}
						} else if (!isMovingBetweenSortable) {
						after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
					}

					var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

					if (moveVector !== false) {
						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}

						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(activeSortable, isOwner);

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'pointercancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			_cancelNextTick(this._cloneId);
			_cancelNextTick(this._dragStartId);

			// Unbind events
			_off(document, 'mouseover', this);
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					// Drag stop event
					_dispatchEvent(this, rootEl, 'unchoose', dragEl, parentEl, rootEl, oldIndex);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, parentEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, parentEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, parentEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, parentEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, parentEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =
			lastDownEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function (/**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'mouseover':
					this._onDrop(evt);
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, toEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = toEl || rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt, willInsertAfter) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();
		evt.willInsertAfter = willInsertAfter;

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.left + rect.width) > 5);
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		if (Polymer && Polymer.dom) {
			return Polymer.dom(el).cloneNode(true);
		}
		else if ($) {
			return $(el).clone(true)[0];
		}
		else {
			return el.cloneNode(true);
		}
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	function _nextTick(fn) {
		return setTimeout(fn, 0);
	}

	function _cancelNextTick(id) {
		return clearTimeout(id);
	}

	// Fixed #973:
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index,
		nextTick: _nextTick,
		cancelNextTick: _cancelNextTick
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.7.0';
	return Sortable;
});


/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function arrayMove(x, from, to) {
	x.splice((to < 0 ? x.length + to : to), 0, x.splice(from, 1)[0]);
}

module.exports = function (x, from, to) {
	x = x.slice();
	arrayMove(x, from, to);
	return x;
};

module.exports.mut = arrayMove;


/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vuetify-crud-datatable"}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogConfirm),callback:function ($$v) {_vm.dialogConfirm=$$v},expression:"dialogConfirm"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.text['delete_element']))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.getConfirmationMessage())+" ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.secundaryButtonColor,"flat":"flat"},nativeOn:{"click":function($event){_vm.dialogConfirm = false}}},[_vm._v(_vm._s(_vm.text['cancel']))]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.primaryButtonColor,"flat":"flat"},on:{"click":function($event){_vm.deleteItem(_vm.editedItemIndex)}}},[_vm._v(_vm._s(_vm.text['delete']))])],1)],1)],1),_vm._v(" "),(_vm.addButton)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":_vm.primaryButtonColor,"dark":true},on:{"click":function($event){_vm.onClickAddButton()}}},[_vm._v("\n      "+_vm._s(_vm.text['new'])+" "+_vm._s(_vm.name)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.markButton && _vm.checkbox !== false && _vm.selected.length > 0)?_c('v-btn',{staticClass:"mb-2",attrs:{"dark":true,"color":"teal"},nativeOn:{"click":function($event){return _vm.markSelected($event)}}},[_vm._v("\n      "+_vm._s(_vm.text['mark_selecteds'])+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.cloneButton && _vm.checkbox !== false && _vm.selected.length > 0)?_c('v-btn',{staticClass:"mb-2",attrs:{"dark":true,"color":"purple darken-1"},nativeOn:{"click":function($event){return _vm.cloneSelected($event)}}},[_vm._v("\n      "+_vm._s(_vm.text['clone_selecteds'])+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.deleteButton && _vm.checkbox !== false && _vm.selected.length > 0)?_c('v-btn',{staticClass:"mb-2",attrs:{"dark":true,"color":"red"},nativeOn:{"click":function($event){return _vm.deleteSelected($event)}}},[_vm._v("\n      "+_vm._s(_vm.text['delete_selecteds'])+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"light":""}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.editedItemIndex !== -1)?_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.editedItem),function(item,i){return (_vm.getItemVisibilityByValue(i) !== false)?_c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.getItemTypeByValue(i) === "editable-text-field")?_c('v-text-field',{attrs:{"label":_vm.getItemLabelByValue(i),"counter":_vm.getItemCounterByValue(i),"rules":[_vm.getItemRulesByValue(i)]},model:{value:(_vm.editedItem[i]),callback:function ($$v) {_vm.$set(_vm.editedItem, i, $$v)},expression:"editedItem[i]"}}):_vm._e(),_vm._v(" "),(_vm.getItemTypeByValue(i) === "select")?_c('v-select',{attrs:{"label":_vm.getItemLabelByValue(i),"item-text":_vm.getItemPropTextByValue(i) || 'text',"item-value":_vm.getItemPropValueByValue(i) || 'value',"items":_vm.getItemOptionsByValue(i)},model:{value:(_vm.editedItem[i]),callback:function ($$v) {_vm.$set(_vm.editedItem, i, $$v)},expression:"editedItem[i]"}}):_vm._e()],1):_vm._e()})):_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.editedItem),function(item,i){return (_vm.getItemVisibilityByValue(i) !== false)?_c('v-flex',{key:i,attrs:{"xs12":"","sm12":"","md12":""}},[(_vm.getItemTypeByValue(i) === "editable-text-field")?_c('v-text-field',{attrs:{"label":_vm.getItemLabelByValue(i),"counter":_vm.getItemCounterByValue(i),"rules":[_vm.getItemRulesByValue(i)]},model:{value:(_vm.editedItem[i]),callback:function ($$v) {_vm.$set(_vm.editedItem, i, $$v)},expression:"editedItem[i]"}}):_vm._e(),_vm._v(" "),(_vm.getItemTypeByValue(i) === "select")?_c('v-select',{attrs:{"label":_vm.getItemLabelByValue(i),"item-text":_vm.getItemPropTextByValue(i) || 'text',"item-value":_vm.getItemPropValueByValue(i) || 'value',"items":_vm.getItemOptionsByValue(i)},model:{value:(_vm.editedItem[i]),callback:function ($$v) {_vm.$set(_vm.editedItem, i, $$v)},expression:"editedItem[i]"}}):_vm._e()],1):_vm._e()}))],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.primaryColor,"flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("\n          "+_vm._s(_vm.text['cancel'])+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.primaryColor,"flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("\n          "+_vm._s(_vm.text['save'])+"\n        ")])],1)],1)],1),_vm._v(" "),_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm._f("capitalize")(_vm.pluralName))+"\n    "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.text['search'] + ' ' + _vm.name,"single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),(_vm.displayFilters)?_c('v-container',{attrs:{"fluid":"","grid-list-lg":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-menu',{ref:"dateFromMenu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.dateFrom,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.dateFrom=$event}},model:{value:(_vm.dateFromMenu),callback:function ($$v) {_vm.dateFromMenu=$$v},expression:"dateFromMenu"}},[[_c('v-text-field',{attrs:{"slot":"activator","label":"Desde","readonly":""},slot:"activator",model:{value:(_vm.dateFromm),callback:function ($$v) {_vm.dateFromm=$$v},expression:"dateFromm"}})],_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-es","first-day-of-week":1,"color":"indigo","no-title":"","scrollable":""},on:{"input":function($event){_vm.saveDate('start')}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-menu',{ref:"dateToMenu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.dateTo,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.dateTo=$event}},model:{value:(_vm.dateToMenu),callback:function ($$v) {_vm.dateToMenu=$$v},expression:"dateToMenu"}},[[_c('v-text-field',{attrs:{"slot":"activator","label":"Hasta","readonly":""},slot:"activator",model:{value:(_vm.dateToo),callback:function ($$v) {_vm.dateToo=$$v},expression:"dateToo"}})],_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-es","first-day-of-week":1,"color":"indigo","no-title":"","scrollable":""},on:{"input":function($event){_vm.saveDate('end')}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.dateOptions,"label":"Filtrar por fecha"},model:{value:(_vm.filterBy),callback:function ($$v) {_vm.filterBy=$$v},expression:"filterBy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.statuses,"label":"Estado"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.business,"label":"Grupo empresarial"},model:{value:(_vm.selectedBusiness),callback:function ($$v) {_vm.selectedBusiness=$$v},expression:"selectedBusiness"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.companies,"label":"Empresa"},model:{value:(_vm.selectedCompany),callback:function ($$v) {_vm.selectedCompany=$$v},expression:"selectedCompany"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.commerces,"label":"Comercio"},model:{value:(_vm.selectedCommerce),callback:function ($$v) {_vm.selectedCommerce=$$v},expression:"selectedCommerce"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","d-flex":""}},[_c('v-select',{staticClass:"filter-select",attrs:{"items":_vm.installers,"label":"Instalador"},model:{value:(_vm.selectedInstaller),callback:function ($$v) {_vm.selectedInstaller=$$v},expression:"selectedInstaller"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.theHeaders,"color":_vm.primaryColor,"items":_vm.items,"loading":false,"disable-initial-sort":true,"rows-per-page-items":_vm.rowsPerPage,"rows-per-page-text":_vm.text['rows_per_page_items'] + ':',"no-results-text":_vm.text['no_results_text'],"no-data-text":_vm.text['no_data_text'],"search":_vm.search,"item-key":_vm.itemKey,"select-all":_vm.checkbox,"pagination":_vm.customPagination},on:{"update:pagination":function($event){_vm.customPagination=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('draggable',{staticClass:"dragArea",attrs:{"options":_vm.getOptions(),"element":"tr","move":_vm.onMove},on:{"start":_vm.onStart,"end":_vm.onEnd},model:{value:(props.headers),callback:function ($$v) {_vm.$set(props, "headers", $$v)},expression:"props.headers"}},_vm._l((props.headers),function(header,index){return _c('th',{key:index,class:header.type !== 'checkbox' && header.type !== 'actions' ? ['column sortable', _vm.customPagination.descending ? 'desc' : 'asc', header.value === _vm.customPagination.sortBy ? 'active' : ''] : 'no-drag',style:('text-align: ' + (header.align ? header.align : 'center')),on:{"click":function($event){header.sortable ? _vm.changeSort(header.value) : false}}},[(header.type === 'checkbox')?_c('v-checkbox',{attrs:{"input-value":props.all,"indeterminate":props.indeterminate,"primary":"","hide-details":""},nativeOn:{"click":function($event){return _vm.toggleAll($event)}}}):_c('span',[_vm._v("\n      "+_vm._s(header.text)+"\n        "),(header.sortable)?_c('v-icon',{attrs:{"small":""}},[_vm._v("arrow_upward")]):_vm._e()],1)],1)}))]}},{key:"items",fn:function(props){return [(_vm.checkbox !== false)?_c('td',{class:_vm.isDragging ? 'opacity-all' : ''},[_c('v-checkbox',{attrs:{"color":_vm.checkbox,"hide-details":"","input-value":props.all,"indeterminate":props.indeterminate},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.sortColumns(props.item)),function(item,i){return (_vm.getItemTypeByValue(i) && i !== 'actions')?_c('td',{key:i,class:_vm.isDragging ? 'opacity-all' : 'opacity-off'},[(_vm.getItemTypeByValue(i) === "span")?_c('span',[_vm._v("\n          "+_vm._s(props.item[i])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.getItemTypeByValue(i) === "select")?_c('span',[_vm._v("\n          "+_vm._s(props.item[i])+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.getItemTypeByValue(i) === "editable-text-field")?_c('v-edit-dialog',{attrs:{"return-value":props.item[i],"lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, i, $event)}}},[_vm._v(" "+_vm._s(props.item[i])+"\n          "),_c('v-text-field',{attrs:{"slot":"input","label":"Edit","single-line":"","counter":_vm.getItemCounterByValue(i),"autofocus":"","rules":[_vm.getItemRulesByValue(i)]},on:{"change":function($event){_vm.editInputText(_vm.getIndexByItemKey(props.item[_vm.itemKey]))}},slot:"input",model:{value:(props.item[i]),callback:function ($$v) {_vm.$set(props.item, i, $$v)},expression:"props.item[i]"}})],1):_vm._e()],1):_vm._e()}),_vm._v(" "),(_vm.actions)?_c('td',{staticClass:"justify-center layout px-0",class:_vm.isDragging ? 'opacity-all' : ''},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editItem(_vm.getIndexByItemKey(props.item[_vm.itemKey]), props.item[_vm.itemKey])}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.confirmDeletion(_vm.getIndexByItemKey(props.item[_vm.itemKey]))}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1):_vm._e()],1):_vm._e()]}},{key:"pageText",fn:function(ref){
var pageStart = ref.pageStart;
var pageStop = ref.pageStop;
return [_vm._v("\n      "+_vm._s(_vm.text['from'])+" "+_vm._s(pageStart)+" "+_vm._s(_vm.text['to'])+" "+_vm._s(pageStop)+"\n    ")]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n      "+_vm._s(_vm.text['no_results_found_for'])+" \""+_vm._s(_vm.search)+"\".\n    ")])],1),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],staticClass:"settings-btn",attrs:{"absolute":"","dark":"","fixed":"","fab":"","bottom":"","right":"","color":"primary"},on:{"click":function($event){_vm.sheet = true}}},[_c('v-icon',[_vm._v("settings")])],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-bottom-sheet',{model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-card',{staticClass:"options-card"},[_c('v-btn',{staticClass:"close",attrs:{"flat":"","icon":"","color":"#757575","absolute":"","right":""},on:{"click":function($event){_vm.sheet = !_vm.sheet}}},[_c('v-icon',{staticClass:"close-icon"},[_vm._v("close")])],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.text['columns'])+" \n          "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-icon',{staticClass:"info-icon",attrs:{"slot":"activator","color":"primary","small":"","dark":""},slot:"activator"},[_vm._v("help_outline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text['columns_info']))])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"checkboxes",attrs:{"fluid":"","grid-list-xl":""}},[_c('v-layout',{attrs:{"column":"","justify-space-between":""}},[_c('ul',_vm._l((_vm.headers),function(header,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(header.type !== 'actions' && header.type !== 'checkbox'),expression:"header.type !== 'actions' && header.type !== 'checkbox'"}],key:header.value,staticClass:"checkbox-column",on:{"click":function($event){_vm.setColumnsVisibility(header.value)}}},[_c('v-checkbox',{attrs:{"label":header.text,"color":"primary","value":header.value,"hide-details":""},model:{value:(_vm.customColumns),callback:function ($$v) {_vm.customColumns=$$v},expression:"customColumns"}})],1)}))])],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.text['restart_columns'])+"\n          "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-icon',{staticClass:"info-icon",attrs:{"slot":"activator","color":"primary","small":"","dark":""},slot:"activator"},[_vm._v("error_outline")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text['columns_warning']))])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"reset-btn",attrs:{"small":"","outline":"","color":"primary","dark":""},on:{"click":function($event){_vm.resetColumns()}}},[_vm._v("\n              "+_vm._s(_vm.text['reset'])+"\n            ")]),_vm._v(" "),(_vm.displayFilters)?_c('v-subheader',[_vm._v("Reiniciar filtros")]):_vm._e(),_vm._v(" "),(_vm.displayFilters)?_c('v-btn',{staticClass:"reset-btn",attrs:{"small":"","outline":"","color":"primary","dark":""},on:{"click":function($event){_vm.resetFilters()}}},[_vm._v("\n              "+_vm._s(_vm.text['reset'])+"\n            ")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mixins_rule__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vue_user_visible_for__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vuetify_crud_datatable__ = __webpack_require__(609);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3_mixins_rule__["a" /* default */]],

  components: {
    VisibleFor: __WEBPACK_IMPORTED_MODULE_4__components_vue_user_visible_for__["a" /* default */],
    VuetifyCrudDatatable: __WEBPACK_IMPORTED_MODULE_5__components_vuetify_crud_datatable__["a" /* default */]
  },

  data: function data() {
    return {
      taxonomyType: this.$route.params.type || '',
      name: '',
      pluralName: '',
      item: {},
      customColumnsResponse: null,
      selectedColumns: [],
      display: false,
      translations: {
        new: 'Nueva',
        delete_selecteds: 'Eliminar seleccionados',
        delete_element_message: 'Estás a punto de eliminar la',
        edit: 'Editar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        save: 'Guardar',
        delete_element: '¡ATENCIÓN!',
        search: 'Buscar',
        rows_per_page_items: 'Filas por página',
        no_results_text: 'No hay datos disponibles',
        no_data_text: 'No hay coincidencias',
        from: 'Desde',
        to: 'hasta',
        no_results_found_for: 'No se encontraron resultados para'
      },
      color: {
        checkbox: 'primary',
        primary: 'primary',
        success: 'success',
        error: 'error',
        button: {
          primary: 'primary',
          secundary: 'primary'
        }
      },
      rowsPerPage: [5, 10, 25, { 'text': 'Todas', 'value': -1 }]
    };
  },
  created: function created() {
    var _this = this;

    this.getCustomColumns().then(function (response) {
      _this.getItems().then(function (response) {
        // console.log(response)
        if (_this.taxonomyType === 'observations') {
          _this.item = _this.normalizeObservations(response.data);
        } else if (_this.taxonomyType === 'materials') {
          _this.item = _this.normalizeMaterials(response.data);
        } else if (_this.taxonomyType === 'typess') {
          _this.item = _this.normalizeTypes(response.data);
        } else if (_this.taxonomyType === 'exclusions') {
          _this.item = _this.normalizeExclusions(response.data);
        } else if (_this.taxonomyType === 'inclusions') {
          _this.item = _this.normalizeInclusions(response.data);
        }
        _this.display = true;
      }).catch(function (error) {
        console.log(error);
      });
    }).catch(function (error) {
      console.log(error);
    });
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeObservations: function normalizeObservations(item) {
      this.name = 'obsevación';
      this.pluralName = 'observaciones';
      item.pagination = this.setPagination(item);
      item.default_columns = this.setObservationsDefaultColumns(item);
      item.headers = this.setObservationsHeaders(item);
      this.setObservationsTranslations();
      return item;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeMaterials: function normalizeMaterials(item) {
      this.name = 'designación de material';
      this.pluralName = 'designaciones de material';
      item.pagination = this.setPagination(item);
      item.default_columns = this.setMaterialsDefaultColumns(item);
      item.headers = this.setMaterialsHeaders(item);
      this.setMaterialsTranslations();
      return item;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeTypes: function normalizeTypes(item) {
      this.name = 'tipo de instalación';
      this.pluralName = 'tipos de instalación';
      item.pagination = this.setPagination(item);
      item.default_columns = this.setTypesDefaultColumns(item);
      item.headers = this.setTypesHeaders(item);
      this.setTypesTranslations();
      return item;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeExclusions: function normalizeExclusions(item) {
      this.name = 'exclusión';
      this.pluralName = 'exclusiones';
      item.pagination = this.setPagination(item);
      item.default_columns = this.setExclusionsDefaultColumns(item);
      item.headers = this.setExclusionsHeaders(item);
      this.setExclusionsTranslations();
      return item;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeInclusions: function normalizeInclusions(item) {
      this.name = 'inclusión';
      this.pluralName = 'inclusiones';
      item.pagination = this.setPagination(item);
      item.default_columns = this.setInclusionsDefaultColumns(item);
      item.headers = this.setInclusionsHeaders(item);
      this.setInclusionsTranslations();
      return item;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setPagination: function setPagination(item) {
      return {
        sortBy: item.item_value,
        descending: true,
        rowsPerPage: -1
      };
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setObservationsDefaultColumns: function setObservationsDefaultColumns(item) {
      var _ref;

      return _ref = {
        value: false
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, item.item_value, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, item.item_text, ''), _ref;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setMaterialsDefaultColumns: function setMaterialsDefaultColumns(item) {
      var _ref2;

      return _ref2 = {
        value: false
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2, item.item_value, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2, item.item_text, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2, item.item_text_2, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2, item.item_text_3, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref2, item.item_text_4, ''), _ref2;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setTypesDefaultColumns: function setTypesDefaultColumns(item) {
      var _ref3;

      return _ref3 = {
        value: false
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_value, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_text, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_text_2, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_text_3, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_text_4, ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref3, item.item_text_5, ''), _ref3;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setExclusionsDefaultColumns: function setExclusionsDefaultColumns(item) {
      var _ref4;

      return _ref4 = {
        value: false
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4, item.item_value, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref4, item.item_text, ''), _ref4;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setInclusionsDefaultColumns: function setInclusionsDefaultColumns(item) {
      var _ref5;

      return _ref5 = {
        value: false
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref5, item.item_value, 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref5, item.item_text, ''), _ref5;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setObservationsHeaders: function setObservationsHeaders(item) {
      return [{
        text: 'ID',
        value: item.item_value,
        align: 'left',
        type: 'span',
        editable: false,
        sortable: true
      }, {
        text: 'Observación',
        align: 'left',
        sortable: true,
        value: item.item_text,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        type: 'actions',
        sortable: false,
        editable: true,
        fixed: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setMaterialsHeaders: function setMaterialsHeaders(item) {
      return [{
        text: 'ID',
        value: item.item_value,
        align: 'left',
        type: 'span',
        editable: false,
        sortable: true
      }, {
        text: 'Designación de material',
        align: 'left',
        sortable: true,
        value: item.item_text,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 1 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_2,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 2 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_3,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 3 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_4,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        type: 'actions',
        sortable: false,
        editable: true,
        fixed: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setTypesHeaders: function setTypesHeaders(item) {
      return [{
        text: 'ID',
        value: item.item_value,
        align: 'left',
        type: 'span',
        editable: false,
        sortable: true
      }, {
        text: 'Tipo de instalación',
        align: 'left',
        sortable: true,
        value: item.item_text,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 1 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_2,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 2 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_3,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Tarifa 3 (€ sin IVA)',
        align: 'left',
        sortable: true,
        value: item.item_text_4,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Duración (horas)',
        align: 'left',
        sortable: true,
        value: item.item_text_5,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        type: 'actions',
        sortable: false,
        editable: true,
        fixed: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setExclusionsHeaders: function setExclusionsHeaders(item) {
      return [{
        text: 'ID',
        value: item.item_value,
        align: 'left',
        type: 'span',
        editable: false,
        sortable: true
      }, {
        text: 'Exclusión',
        align: 'left',
        sortable: true,
        value: item.item_text,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        type: 'actions',
        sortable: false,
        editable: true,
        fixed: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setInclusionsHeaders: function setInclusionsHeaders(item) {
      return [{
        text: 'ID',
        value: item.item_value,
        align: 'left',
        type: 'span',
        editable: false,
        sortable: true
      }, {
        text: 'Inclusión',
        align: 'left',
        sortable: true,
        value: item.item_text,
        type: 'editable-text-field',
        editable: true,
        main: true,
        rules: function rules(v) {
          return v.length <= 255 || '¡Texto demasiado largo!';
        },
        counter: 255
      }, {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        type: 'actions',
        sortable: false,
        editable: true,
        fixed: true
      }];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCustomColumns: function getCustomColumns() {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = parseInt(_this2.$store.getters['api/getUserId']);
        _this2.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/option/' + userID + '/' + _this2.taxonomyType + '_columns/'
        }).then(function (response) {
          _this2.customColumnsResponse = response.data;
          _this2.selectedColumns = JSON.parse(_this2.customColumnsResponse.user_option_value);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this2.$store.dispatch('snackbar/show', 'Error al obtener la disposición de las columnas: ' + _this2.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateCustomColumns: function updateCustomColumns() {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = parseInt(_this3.$store.getters['api/getUserId']);
        _this3.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'user/option/' + userID + '/' + _this3.taxonomyType + '_columns/',
          data: {
            option_id: _this3.customColumnsResponse.user_option_id,
            option_value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.selectedColumns)
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this3.$store.dispatch('snackbar/show', 'Error al actualizar la disposición de las columnas: ' + _this3.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeColumns: function onChangeColumns(customColumns) {
      this.selectedColumns = customColumns;
      this.updateCustomColumns();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setObservationsTranslations: function setObservationsTranslations() {
      this.translations.columns = 'Columnas';
      this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro';
      this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto';
      this.translations.restart_columns = 'Reiniciar columnas';
      this.translations.reset = 'Reiniciar';
      this.translations.new = 'Nueva';
      this.translations.delete_selecteds = 'Eliminar seleccionadas';
      this.translations.delete_element_message = 'Estás a punto de eliminar la';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setMaterialsTranslations: function setMaterialsTranslations() {
      this.translations.columns = 'Columnas';
      this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro';
      this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto';
      this.translations.restart_columns = 'Reiniciar columnas';
      this.translations.reset = 'Reiniciar';
      this.translations.new = 'Nueva';
      this.translations.delete_selecteds = 'Eliminar seleccionadas';
      this.translations.delete_element_message = 'Estás a punto de eliminar la';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setTypesTranslations: function setTypesTranslations() {
      this.translations.columns = 'Columnas';
      this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro';
      this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto';
      this.translations.restart_columns = 'Reiniciar columnas';
      this.translations.reset = 'Reiniciar';
      this.translations.new = 'Nuevo';
      this.translations.delete_selecteds = 'Eliminar seleccionados';
      this.translations.delete_element_message = 'Estás a punto de eliminar el';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setExclusionsTranslations: function setExclusionsTranslations() {
      this.translations.columns = 'Columnas';
      this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro';
      this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto';
      this.translations.restart_columns = 'Reiniciar columnas';
      this.translations.reset = 'Reiniciar';
      this.translations.new = 'Nueva';
      this.translations.delete_selecteds = 'Eliminar seleccionadas';
      this.translations.delete_element_message = 'Estás a punto de eliminar la';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setInclusionsTranslations: function setInclusionsTranslations() {
      this.translations.columns = 'Columnas';
      this.translations.columns_info = 'Además de seleccionar qué columnas mostrar u ocultar puedes modificar su orden arrastrándolas de un lugar a otro';
      this.translations.columns_warning = 'ATENCIÓN: Esto eliminará tu selección personalizada y restablecerá las columnas a la selección por defecto';
      this.translations.restart_columns = 'Reiniciar columnas';
      this.translations.reset = 'Reiniciar';
      this.translations.new = 'Nueva';
      this.translations.delete_selecteds = 'Eliminar seleccionadas';
      this.translations.delete_element_message = 'Estás a punto de eliminar la';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getItems: function getItems() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'installation/' + _this4.taxonomyType + '/'
        }).then(function (response) {
          // console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this4.$store.dispatch('snackbar/show', 'Error al obtener el perfil: ' + _this4.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *pause_circle_filled
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem(index) {
      var _this5 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'installation/' + this.taxonomyType + '/',
        data: this.getValues(index)
      }).then(function (response) {
        // console.log(response.data)
        _this5.item.items[index][_this5.item.item_value] = response.data;
        _this5.$store.dispatch('snackbar/show', '¡Hecho!');
      }).catch(function (error) {
        console.log(error);
        _this5.$store.dispatch('snackbar/show', 'Error al guardar: ' + _this5.$store.getters['api/getMessage']);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getValues: function getValues(index) {
      if (this.taxonomyType === 'observations') {
        return {
          value: this.item.items[index][this.item.item_text]
        };
      } else if (this.taxonomyType === 'materials') {
        return {
          name: this.item.items[index][this.item.item_text],
          rate_1: this.item.items[index][this.item.item_text_2],
          rate_2: this.item.items[index][this.item.item_text_3],
          rate_3: this.item.items[index][this.item.item_text_4]
        };
      } else if (this.taxonomyType === 'types') {
        return {
          name: this.item.items[index][this.item.item_text],
          rate_1: this.item.items[index][this.item.item_text_2],
          rate_2: this.item.items[index][this.item.item_text_3],
          rate_3: this.item.items[index][this.item.item_text_4],
          duration: this.item.items[index][this.item.item_text_5]
        };
      } else if (this.taxonomyType === 'exclusions') {
        return {
          value: this.item.items[index][this.item.item_text]
        };
      } else if (this.taxonomyType === 'inclusions') {
        return {
          value: this.item.items[index][this.item.item_text]
        };
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onEditItem: function onEditItem(index) {
      var _this6 = this;

      var id = this.item.items[index][this.item.item_value];
      this.$store.dispatch('api/authRequest', {
        method: 'put',
        url: 'installation/' + this.taxonomyType + '/' + id + '/',
        data: this.getValues(index)
      }).then(function (response) {
        console.warn(response);
        _this6.$store.dispatch('snackbar/show', '¡Hecho!');
      }).catch(function (error) {
        console.log(error);
        _this6.$store.dispatch('snackbar/show', 'Error al guardar: ' + _this6.$store.getters['api/getMessage']);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDeleteItem: function onDeleteItem(index) {
      var _this7 = this;

      var id = this.item.items[index][this.item.item_value];
      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'installation/' + this.taxonomyType + '/' + id + '/'
      }).then(function (response) {
        // console.log(response.data)
        _this7.$store.dispatch('snackbar/show', '¡Hecho!');
      }).catch(function (error) {
        console.log(error);
        _this7.$store.dispatch('snackbar/show', 'Error al guardar: ' + _this7.$store.getters['api/getMessage']);
      });
    }
  }
});

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(856);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("328fba2b", content, true, {});

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".application{background:rgba(63,81,181,.0705882)!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/taxonomies.vue"],"names":[],"mappings":"AACA,aACE,6CAAoD,CACrD","file":"taxonomies.vue","sourcesContent":["\n.application {\n  background: rgba(63, 81, 181, 0.0705882) !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"page-title display-1"},[_vm._v(_vm._s(_vm.capitalize(_vm.pluralName)))]),_vm._v(" "),_c('visible-for',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],attrs:{"superadmin":"","administrator":"","supervisor":""}},[_c('vuetify-crud-datatable',{attrs:{"slot":"content","name":_vm.name,"plural-name":_vm.pluralName,"rows-per-page-items":_vm.rowsPerPage,"translations":_vm.translations,"headers":_vm.item.headers || [],"rows":_vm.item.items || [],"actions":false,"item-key":_vm.item.item_value,"pagination":_vm.item.pagination,"defaultColumns":_vm.item.default_columns || {},"primary-color":_vm.color.primary,"checkbox-color":_vm.color.checkbox,"primary-button-color":_vm.color.button.primary,"secundary-button-color":_vm.color.button.secundary,"selected-columns":_vm.selectedColumns},on:{"on-edit":_vm.onEditItem,"on-delete":_vm.onDeleteItem,"on-add":_vm.onAddItem,"on-change-columns":_vm.onChangeColumns},slot:"content"})],1),_vm._v(" "),_c('pre',[_vm._v("\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.9fb50d459bfda3b3a273.js